var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* istanbul ignore next */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
/* istanbul ignore next */
export var Logger = {
    ENABLED: typeof window !== 'undefined' &&
        typeof location !== 'undefined' &&
        location.search.indexOf('giphy-debug') !== -1,
    LEVEL: 0,
    PREFIX: 'GiphyJS',
    debug: function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        if (Logger.ENABLED && Logger.LEVEL <= LogLevel.DEBUG) {
            console.debug.apply(console, __spreadArray([Logger.PREFIX], msg, false)); // eslint-disable-line no-console
        }
    },
    info: function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        if (Logger.ENABLED && Logger.LEVEL <= LogLevel.INFO) {
            console.info.apply(console, __spreadArray([Logger.PREFIX], msg, false)); // eslint-disable-line no-console
        }
    },
    warn: function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        if (Logger.ENABLED && Logger.LEVEL <= LogLevel.WARN) {
            console.warn.apply(console, __spreadArray([Logger.PREFIX], msg, false)); // eslint-disable-line no-console
        }
    },
    error: function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        if (Logger.ENABLED && Logger.LEVEL <= LogLevel.ERROR) {
            console.error.apply(console, __spreadArray([Logger.PREFIX], msg, false)); // eslint-disable-line no-console
        }
    },
};
//# sourceMappingURL=log.js.map